// removed by extract-text-webpack-plugin
module.exports = {"Footer":"Footer__Footer__102n5","ButtonsContainer":"Footer__ButtonsContainer__1jwTM","ButtonInvisible":"Footer__ButtonInvisible__1TYqH","ButtonContinueContainer":"Footer__ButtonContinueContainer__2D1CJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Footer/Footer.css
// module id = 135
// module chunks = 0